import React from 'react';

/**
 * Pill-style segmented control for switching between views.
 * @param {string} activeId - Currently active item id
 * @param {function} onChange - Callback when selection changes
 * @param {Array} items - Array of { id, label, icon? }
 * @param {string} className - Optional wrapper class names
 */
export const SegmentedControl = ({ activeId, onChange, items, className = '' }) => {
    return (
        <div className={`segmented-control ${className}`.trim()}>
            {items.map((item) => {
                const Icon = item.icon;
                const isActive = activeId === item.id;

                return (
                    <button
                        key={item.id}
                        type="button"
                        onClick={() => onChange(item.id)}
                        className={`flex items-center gap-2 ${isActive ? 'active' : ''}`}
                    >
                        {Icon && <Icon className="w-3.5 h-3.5" />}
                        {item.label}
                    </button>
                );
            })}
        </div>
    );
};
